<template>
<a-spin :spinning="spinning" tip="Loading...">
    <div class="card mb-3">
        <div class="row no-gutters">
            <div class="col-md-12" style="border-right: 1px solid #e0e0e0">
                <div class="card-body">
                    <div class="row">
                        <div class="col-md-7 align-self-center">
                            <div v-if="reportDescription != ''" class="card">
                                <div class="card-body">
                                    <div class="card-text">
                                        {{ reportDescription }}
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                    <div class="row">
                        <div class="col-md-4">
                            <base-input alternative="" label="From"><br>
                                <a-range-picker v-model="inputDate" :showTime="{ format: 'hh:mm' }" :format="dateFormat" :placeholder="datePickerPlaceholder" style="width:100%"/>
                            </base-input>
                        </div>
                        <div class="col-md-4">
                            <base-input label="Sort By" >
                                <select class="form-control" size="large" v-model="inputSortBy">
                                    <option v-for="option in sortOptions" v-bind:value="option.key" v-bind:key="option.key">
                                        {{ option.value }}
                                    </option>
                                </select>
                            </base-input>
                        </div>
                        <div class="col-md-2 mt-3 pt-3">
                            <button type="button" class="btn btn-sm btn-link" @click='showSortInfoDiv' > 
                                {{showSortInfo == 'asc' ? 'Ascending (A-Z) ↡' : 'Descending (Z-A) ↟'}} 
                            </button>
                        </div>
                    </div>
                    <div class="row">
                        <!-- <div class="col-md-4">
                            <base-input label="Group By" >
                                <select class="form-control" v-model="inputGroupBy">
                                    <option v-for="option in groupOptions" v-bind:value="option.key" v-bind:key="option.key">
                                        {{ option.value }}
                                    </option>
                                </select>
                            </base-input>
                        </div> -->
                        <div class="col-md-4">
                            <base-input label="Filtered By" >
                                <select class="form-control" v-model="inputFilterBy">
                                    <option v-for="option in filterOptions" v-bind:value="option.key" v-bind:key="option.key">
                                        {{ option.value }}
                                    </option>
                                </select>
                            </base-input>
                        </div>
                        <div class="col-md-4">
                            <base-input alternative="" label="Select Site">
                                <a-select mode="multiple" v-model="inputSite" showSearch placeholder="All Sites" optionFilterProp="children" style="width: 100%" :filterOption="filterOption" :disabled="site_type != 'ho'">
                                    <a-select-option v-for="option in siteOptions" :key="option.id" :value="option.id">{{option.name}}</a-select-option>
                                </a-select>
                            </base-input>
                        </div>
                    </div>
                    
                    
                    <div class="row">
                        <div class="col-md-12">
                            <br>
                            <button v-if="jsonData.length < 1" class="btn btn-sm btn-default float-right" style="border-radius: 24px; border:0px; width: 20%;" @click.prevent="excelData">Generate Report in Excel</button>
                            <button v-if="jsonData.length > 0" class="btn btn-sm btn-success float-right" style="border-radius: 24px; border:0px; width: 20%;" @click.prevent="generateExcel"> Download excel </button> &nbsp; &nbsp;
                            <button class="btn btn-sm btn-default float-right"
                                    style="border-radius: 24px; border:0px; width: 20%;"
                                    @click.prevent="generateReport">
                                Generate Report in PDF
                            </button> &nbsp; &nbsp;
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
</a-spin>
</template>

<script>
    import HTTPRequest from '../../controllers/httpRequest.js'
    import secureStorage from '../../controllers/secureStorage.js';
    import moment from 'moment';
    import jsPDF from 'jspdf';
    import 'jspdf-autotable';
    import { getReportDescription } from '../../utilities.js';
    import * as ExcelJS from "exceljs";
    import { saveAs } from "file-saver";

    import {
        mapState
    } from 'vuex'

    export default {
        data() {
            return {
                spinning: false,
                inputSortBy: 'terminal_name',
                inputGroupBy: '',
                inputFilterBy: 2,
                inputSite: [],
                site_type: "ho",
                inputDate: [moment().startOf('day'), moment().endOf('day')],
                sortOptions: [
                    {key: 'terminal_name', value: 'Terminal'},
                    {key: 'document_date', value: 'Date Time'}
                ],
                groupOptions: [
                    {key: '', value: '[Flat List]'},
                    {key: 'terminal_id', value: 'Terminal'},
                    {key: 'customer_id', value: 'Customer'}
                ],
                filterOptions: [
                    {key: 0, value: '[All Members]'},
                    {key: 1, value: '[Non-Members]'},
                    {key: 2, value: '[All Customers]'}
                ],
                siteOptions: [],
                dateFormat: 'MM/DD/YYYY hh:mm A',
                datePickerPlaceholder: ['Start', 'End'],
                birSalesReports: [],

                showSortInfo: 'asc',
                excelFileName: "void_sales_reports",
                reportDescription: '',
                jsonData: [],
            }
        },
        mounted: async function () {
            var component_x = this;

            var userId = secureStorage.getItem("userId")
            var sites = await HTTPRequest.getRequest(component_x.endPoint + "sites/get_valid_sites?user_id=" + userId, null);
            component_x.siteOptions = sites;
            component_x.sort(component_x.siteOptions);

            let siteId = secureStorage.getItem("defaultSiteId")
            this.inputSite = [siteId]
            this.reportDescription = await getReportDescription(this.currentProfile)

            let site = await HTTPRequest.getRequest(component_x.endPoint + "/sites/" + siteId, null)
            if(site != undefined){
                component_x.site_type = site.site_type
            }
        },
        computed: {
            ...mapState(['currentProfile', 'currentApiURL', 'endPoint', 'parameters']),
        },
        methods: {
            moment,
            filterOption(input, option) {
                return option.componentOptions.children[0].text.toLowerCase().indexOf(input.toLowerCase()) >= 0
            },
            sort(data){
                data.sort(function (a, b) {
                    return a.name.localeCompare(b.name);
                });
            },
            // Advanced Info
            showSortInfoDiv(){
                this.showSortInfo == 'asc' ? this.showSortInfo = 'desc' : this.showSortInfo = 'asc'
            },
            convertToCurrency(num){
                return num.toFixed(2).replace(/(\d)(?=(\d{3})+(?!\d))/g, '$1,')
            },
            openNotificationWithIcon(type, msg) {
                if(type == 'error'){
                    this.$notification[type]({
                        message: 'Export Error',
                        description: msg 
                    });
                }else if(type == 'warning'){
                    this.$notification[type]({
                        message: 'No Data Found',
                        description: msg 
                    });
                }
            },
            generateReport: async function () {
                this.spinning= true;
                // var get_request = {}

                if(this.inputDate.length == 0){
                    this.openNotificationWithIcon('error', 'Please make sure to check your current filters.');
                    this.spinning= false;
                    return
                }
                
                let get_request = await HTTPRequest.getRequest(this.endPoint + 'pos_documents/void_5_1_sales?site_id=' + this.inputSite + 
                        '&date_from=' + this.inputDate[0].format('YYYY-MM-DD HH:mm:ss') + '&date_to=' + this.inputDate[1].format('YYYY-MM-DD HH:mm:ss') + 
                        '&order=' + this.inputSortBy + '&by=' + this.showSortInfo + '&group=' + this.inputGroupBy + '&filter=' + this.inputFilterBy, null)
                if(get_request.error) {
                    this.openNotificationWithIcon('error', get_request.error);
                    this.spinning= false;
                    return
                }
                var siteSpecific = get_request;

                if(siteSpecific.length > 0){
                    var doc = new jsPDF({ orientation: 'landscape', unit: 'mm', format: 'a2' });

                    // let reportLogo = document.getElementById('reportLogo');
                    // doc.addImage(reportLogo, "PNG", 30, 0, 30, 15);

                    let header_detail = [
                        {content: 'DateTime', rowSpan: 1, styles: {halign: 'center'}},
                        {content: 'Void Slip No.', rowSpan: 1, styles: {halign: 'center'}},
                        {content: 'Transaction ID', rowSpan: 1, styles: {halign: 'center'}},
                        {content: 'Ref SI#', rowSpan: 1, styles: {halign: 'center'}},
                        {content: 'Customer Name', colSpan: 1, rowSpan: 1, styles: {halign: 'center'}},
                        {content: 'Cashier', rowSpan: 1, styles: {halign: 'center'}},
                        {content: 'Supervisor', colSpan: 1, rowSpan: 1, styles: {halign: 'center'}},
                        {content: 'Reason', colSpan: 1, rowSpan: 1, styles: {halign: 'center'}},
                        {content: 'Net Amount', colSpan: 1, rowSpan: 1, styles: {halign: 'center'}},
                    ]
                    
                    var headers = [header_detail];

                    let g_total_net = 0

                    for(var x=0; x < siteSpecific.length; x++){
                        this.birSalesReports = siteSpecific[x].report_details

                        if(x > 0 && this.birSalesReports.length > 0){
                            doc.addPage();
                        }

                        if(this.birSalesReports.length > 0){
        
                            let total_total_net = 0

                            let site_total_net = 0

                            var reportData = [];

                            let grouper = '';
                            let grouper_text = '';

                            for(var i=0; i < this.birSalesReports.length; i++){
                                let reportLine = this.birSalesReports[i]

                                if(this.inputGroupBy == 'terminal_id'){
                                    if(grouper == ''){
                                        let detail_header = ["Terminal :", reportLine.terminal_code]
                                        reportData.push(Object.assign({}, detail_header))
                                    } else {
                                        if(grouper != reportLine.terminal_id){
                                            let detail_header = ['Terminal :', reportLine.terminal_code];
                                            reportData.push(Object.assign({}, detail_header))
                                        }
                                    }
                                    grouper = reportLine.terminal_id
                                }else if(this.inputGroupBy == 'customer_id'){
                                    if(grouper == '' && grouper_text == ''){
                                        let detail_header = ["Customer :", reportLine.customer_name]
                                        reportData.push(Object.assign({}, detail_header))
                                        
                                    } else {
                                    if(grouper != reportLine.customer_id){
                                            let detail_header = ['Customer :', reportLine.customer_name];
                                            reportData.push(Object.assign({}, detail_header))
                                        } else {
                                            if(reportLine.customer_id == 0){
                                                let current_grouper = reportLine.customer_name
                                                let prev_grouper = this.birSalesReports[i-1].customer_name
                                                if(current_grouper != prev_grouper){
                                                    let detail_header = ['Customer :', reportLine.customer_name];
                                                    reportData.push(Object.assign({}, detail_header))
                                                }
                                            }
                                        }
                                    }

                                    grouper = reportLine.customer_id
                                    grouper_text = reportLine.customer_name
                                }


                            
                                var detail = [
                                    moment(reportLine.document_date).format('MM/DD/YYYY hh:mm a'), 
                                    reportLine.void_slip_no, 
                                    reportLine.trans_id, 
                                    reportLine.reference_sales_no,
                                    reportLine.customer_name,
                                    reportLine.user_name,
                                    reportLine.approver,
                                    reportLine.reason,
                                    this.convertToCurrency(Number(reportLine.amount_net)),
                                ]


                                reportData.push(Object.assign({}, detail))

                            
                                total_total_net += Number(reportLine.amount_net);
                                site_total_net += Number(reportLine.amount_net);

                            
                                if(i == this.birSalesReports.length-1){
                                    if(this.inputGroupBy != ''){
                                        let total = [
                                            '', '', '', '', '', '', '',
                                            "Total :",
                                            this.convertToCurrency(total_total_net)
                                        ]
                                        reportData.push(Object.assign({}, ["rowLine"]))
                                        reportData.push(Object.assign({}, total))
                                    }
                                    
                                    let site_total = [
                                        '', '', '', '', '', '', '',
                                        "Site Total :",
                                        this.convertToCurrency(site_total_net)
                                    ]
                                    reportData.push(Object.assign({}, ["rowLine"]))
                                    reportData.push(Object.assign({}, site_total))
                                } else {
                                    let current_grouper = ""
                                    let next_grouper = ""

                                    if(this.inputGroupBy == 'terminal_id'){
                                        current_grouper = reportLine.terminal_id
                                        next_grouper = this.birSalesReports[i+1].terminal_id
                                    } else if(this.inputGroupBy == 'customer_id'){
                                        if(reportLine.customer_id == 0){
                                            current_grouper = reportLine.customer_name
                                            next_grouper = this.birSalesReports[i+1].customer_name
                                        } else {
                                            current_grouper = reportLine.customer_id
                                            next_grouper = this.birSalesReports[i+1].customer_id
                                        }
                                    }

                                    if(current_grouper != next_grouper){
                                        if(this.inputGroupBy != ''){
                                            let total = [
                                                '', '', '', '', '', '', '',
                                                "Total :",
                                                this.convertToCurrency(total_total_net)
                                            ]
                                            reportData.push(Object.assign({}, ["rowLine"]))
                                            reportData.push(Object.assign({}, total))

                                            total_total_net = 0
                                        }
                                    }
                                }
                            }

                            
                            g_total_net += site_total_net

                            if(x == siteSpecific.length-1){
                                let grand_total = [
                                    '', '', '', '', '', '', '',
                                    "Grand Total :",
                                    this.convertToCurrency(g_total_net)
                                ]
                                reportData.push(Object.assign({}, ["rowLine"]))
                                reportData.push(Object.assign({}, grand_total))
                            }
                        }

                        doc.setFontSize(16);
                        doc.setFontType("bold");

                        let grouper_name = ""
                        if(this.inputGroupBy == 'customer_id'){
                            grouper_name = " BY CUSTOMER"
                        } else if (this.inputGroupBy == "terminal_id"){
                            grouper_name = " BY TERMINAL"
                        } else if (this.inputGroupBy == "user_id"){
                            grouper_name = " BY CASHIER"
                        }
                        var pageWidth = doc.internal.pageSize.getWidth()/2;

                        doc.text(pageWidth,20,"Void Sales Report" + grouper_name, { align: 'center' })
                        doc.text(pageWidth,27, siteSpecific[x].report_details[0].site_name, { align: 'center' })
                        doc.text(pageWidth,34, siteSpecific[x].report_details[0].site_address, { align: 'center' })
                        doc.text(pageWidth,41, siteSpecific[x].report_details[0].site_tin, { align: 'center' })
                        
                        doc.setFontSize(12);
                        doc.setFontType("normal");

                        doc.text(30,58,"Software")
                        doc.text(95,58, ": barter RPOS 5.1")
                        doc.text(30,65,"Serial Number") 
                        doc.text(95,65,": " + siteSpecific[x].report_details[0].serial_no)
                        doc.text(30,72,"Machine Identification Number")
                        doc.text(95,72,": " + siteSpecific[x].report_details[0].machine_number)
                        doc.text(30,79,"POS Terminal")
                        doc.text(95,79,": " + siteSpecific[x].report_details[0].terminal_code) 
                        doc.text(30,86,"Business Day Period")
                        doc.text(95,86,": From " + this.inputDate[0].format('MMM D, YYYY h:mm A')  + " to " + this.inputDate[1].format('MMM D, YYYY h:mm A'))

                        doc.autoTable({
                            startY: 100, 
                            head: headers, 
                            body: reportData, 
                            theme: 'plain',
                            tableWidth: 'auto',
                            headStyles: {
                                lineWidth: 0.15,
                                cellPadding: 3
                            },
                            styles: {
                                cellPadding: 3, fontSize: 14,
                                halign: 'right'
                            },
                            margin: { left: 30, right: 30},

                            columnStyles: {
                                0: {cellWidth: 'auto'},
                                1: {cellWidth: 'auto'},
                                2: {cellWidth: 'auto'},
                                3: {cellWidth: 'auto'},
                                4: {cellWidth: 'auto'},
                                5: {cellWidth: 'auto'},
                                6: {cellWidth: 'auto'},
                                7: {cellWidth: 'auto'},
                                8: {cellWidth: 'auto', halign: 'left'} 
                            }, 
                            didParseCell: function(data) {
                                if (data.row.section == 'body' && data.row.raw[0] == 'rowLine'){
                                    data.cell.styles.fillColor = [0, 0, 0]
                                    data.cell.styles.fontSize = 1
                                    data.cell.styles.cellPadding = 0
                                } else if (data.row.section == 'body' && (data.row.raw[3] == 'Total :' || data.row.raw[3] == 'Site Total :' || data.row.raw[3] == 'Grand Total :')){
                                    data.cell.styles.fontStyle = 'bold'
                                }
                            },
                        });

                        let footer = ""
                        if(this.inputGroupBy == 'customer_id'){
                            footer = " by Customer"
                        } else if (this.inputGroupBy == "terminal_id"){
                            footer = " by Terminal"
                        } else if (this.inputGroupBy == "user_id"){
                            footer = " by Cashier"
                        }

                        doc.text(30,400,"Printed By: " + secureStorage.getItem("email"))
                        
                            doc.text(580,400,"Void Sales Report" + footer, "right")

                        doc.text(30,405,"Print Date: " + moment().format(this.dateFormat))
                        doc.text(580,405,"Page " + ( x + 1)  + " of " + siteSpecific.length, "right")
                    }
                        window.open(URL.createObjectURL(doc.output("blob")))
                } else {
                    this.openNotificationWithIcon('warning', 'Try increasing the scope by adjusting the filters.');
                }
                this.spinning= false;
            },
            excelData: async function() {
              this.spinning= true;
              var jsonData = [];
              let request = {};
              let total_sales = 0
              let total_vat = 0
              let total_vat_ex = 0
              let total_discount = 0
              let total_net = 0
              let site_specific = []

                if(this.inputDate.length == 0){
                    this.openNotificationWithIcon('error', 'Please make sure to check your current filters.');
                    this.spinning= false;
                    return
                }

                request = await HTTPRequest.getRequest(this.endPoint + 'pos_documents/void_5_1_sales?site_id=' + this.inputSite + 
                        '&date_from=' + this.inputDate[0].format('YYYY-MM-DD HH:mm:ss') + '&date_to=' + this.inputDate[1].format('YYYY-MM-DD HH:mm:ss') + 
                        '&order=' + this.inputSortBy + '&by=' + this.showSortInfo + '&group=' + this.inputGroupBy + '&filter=' + this.inputFilterBy, null)
                
                if (!request[0]) {
                    this.openNotificationWithIcon('warning', 'Try increasing the scope by adjusting the filters.');
                    this.spinning= false;
                    return;
                }
                var siteSpecific = request;
                var header_details = [
                    "","","","","Void Sales Report",
                    "","","",""
                    ]
                jsonData.push(header_details)


                var header = [
                    "Date Time",
                    "Void Slip No.",
                    "Transaction ID",
                    "Ref SI#",
                    "Customer Name",
                    "Cashier",
                    "Supervisor",
                    "Reason",
                    "Net Amount"
                ]
                
                        
                for(var x=0; x < siteSpecific.length; x++){
                    var reportDetails = siteSpecific[x].report_details;
                    jsonData.push([
                    "","","","",reportDetails[0].site_name,
                    "","","",""
                    ])
                    jsonData.push([
                    "","","","",reportDetails[0].site_address,
                    "","","",""
                    ])
                    jsonData.push([
                    "","","","",reportDetails[0].site_tin,
                    "","","",""
                    ])
                    jsonData.push([
                    "Software ","",": Barter RPOS 5.1","","",
                    "","","",""
                    ])
                    jsonData.push([
                    "Serial Number","",": "+reportDetails[0].serial_no,"","",
                    "","","",""
                    ])
                    jsonData.push([
                    "Machine Identification Number","",": "+reportDetails[0].machine_number,"","",
                    "","","",""
                    ])
                    jsonData.push([
                    "POS Terminal","",": "+reportDetails[0].terminal_code,"","",
                    "","","",""
                    ])
                    jsonData.push([
                    "Business Day Period","",": From " + this.inputDate[0].format('MMM D, YYYY h:mm A'),"to " + this.inputDate[1].format('MMM D, YYYY h:mm A'),"",
                    "","","",""
                    ])
                        
                    jsonData.push([])
                    jsonData.push(header)
                    reportDetails.map(detail => {
                        let details = []
                        total_net += Number(detail.amount_net) 
                        
                        details = [
                            moment(detail.document_date).format('MM/DD/YYYY hh:mm a'), 
                                    detail.void_slip_no, 
                                    detail.trans_id, 
                                    detail.reference_sales_no,
                                    detail.customer_name,
                                    detail.user_name,
                                    detail.approver,
                                    detail.reason,
                                    this.convertToCurrency(Number(detail.amount_net)),
                        ]
                        jsonData.push(details)
                    })


                    var footer = [
                        '','',
                        '','',
                        '','','',
                        'Grand Total:',
                        this.convertToCurrency(Number(total_net)),
                    ]
                    jsonData.push(footer)

                    let keys = header;
                    let values = jsonData;
                    var values_length = values.length;

                    let newJsonData=[];

                    // change headers and report data as key and value object
                    for(var i=0;i < values_length; i++){
                        var result =  Object.assign.apply({}, keys.map( (val, index) => ( {
                                    [val]: values[i][index]
                                }
                            )
                        )
                        );
                        newJsonData.push(result)
                    }

                    // change undefined on arr
                    newJsonData.forEach(function(obj) {
                        for(var i in obj) {
                        if(obj[i] === undefined || obj[i] === null ) {
                            obj[i] = '';
                        }
                        }
                    });
                    site_specific.push(newJsonData)
                }
                this.spinning= false;
                this.jsonData = site_specific.flat(Infinity)
            },
            async generateExcel(){
                const workbook = new ExcelJS.Workbook();
                workbook.created = new Date();
                workbook.modified = new Date();
                const sheet = workbook.addWorksheet("Void Sales Reports", {
                    pageSetup:{paperSize: 1}
                });

                const data_starts_at_row = 12

                // var header = [
                //     "Date Time",
                //     "Name of Void",
                //     "ID #",
                //     "SI#",
                //     "Gross Sales",
                //     "Discount",
                //     "Net Sales"
                // ]

                //custom header
                var report_details = this.jsonData
                
                let excelRow = 1;

                // write header block dynamically
                for (let i = 0; i <= 9; i++) {
                    sheet.getRow(excelRow).values = Object.values(report_details[i]);
                    sheet.getRow(excelRow).font = { bold: i <= 3 };
                    excelRow++;
                }
 
                sheet.getRow(data_starts_at_row).values = [

                            "Date Time","Void Slip No.","Transaction ID","Ref SI#","Customer Name","Cashier","Supervisor","Reason","Net Amount"];
                            
            
                            sheet.columns = [
                            { key: "document_date", width: 20 },
                            { key: "void_slip_no" , width: 20 },
                            { key: "trans_id" , width: 30 },
                            { key: "reference_sales_no" , width: 30 },
                            { key: "customer_name", width: 15 },
                            { key: "user_name", width: 10 },
                            { key: "approver", width: 10 },
                            { key: "reason", width: 10 },
                            { key: "amount_net", width: 10 }
                        ];
                
                // var report_details = get_request[0].report_details
                // console.log("details", report_details)
                var rowDatas = []
                console.log(report_details)
                for(let i = 0; i < report_details.length; i++){
                    if (i >= 11){
                        const report_detail = report_details[i]

                        var rowData = {
                            document_date: report_detail["Date Time"],
                            void_slip_no: report_detail["Void Slip No."],
                            trans_id: report_detail["Transaction ID"],
                            reference_sales_no: report_detail["Ref SI#"],
                            customer_name: report_detail["Customer Name"],
                            user_name: report_detail["Cashier"],
                            approver: report_detail["Supervisor"],
                            reason: report_detail["Reason"],
                            amount_net: report_detail["Net Amount"]
                        }
                        rowDatas.push(rowData)
                    }

                }
                sheet.addRows(rowDatas);

                //styles
                // sheet.getRow(4).font = { bold: true, size: 16 };
                // sheet.getRow(4).height = 20;
                // sheet.getRow(7).font = { bold: true };
                sheet.getRow(data_starts_at_row).font = { bold: true };

                // sheet.getRow(data_starts_at_row).eachCell({ includeEmpty: true }, function(cell) {
                //     sheet.getCell(cell.address).fill = { type: 'pattern', pattern: 'darkVertical', fgColor: { argb: '89CFF0'}}
                // })
                sheet.eachRow(function (Row, rowNum) {
                    if(rowNum >= data_starts_at_row){
                        Row.eachCell(function (Cell, cellNum) {
                            if (rowNum == data_starts_at_row) {
                                Cell.alignment = {
                                    horizontal: 'center'
                                }
                            }
                            else{
                                Cell.alignment = {
                                    vertical: 'middle',
                                    horizontal: 'left'
                                }
                            }
                        })
                    }
                })
                
                workbook.xlsx.writeBuffer().then(function(buffer) {
                    const blob = new Blob([buffer], { type: "applicationi/xlsx" });
                    saveAs(blob, `void_sales_report.xlsx`);
                });
                this.jsonData = []
            },
        }
    };
</script>

<style></style>
